<div class="chart-container" #chartParent>

<svg class="multi-chart" [id]="'chart-container'" #chartContainer></svg>
</div>
